export function nbspSpace(children) {
  return children.trim().replace(/(([0-9] ?)+),[0-9]{0,2}/g, x => {
    return x.split(' ').join('\u0009')
  })
}

export function trimName(children) {
  const arr = nbspSpace(children).split(' ')
  arr.length = arr.length > 3 ? 3 : arr.length
  return {
    isTrimmed: arr.length !== 1,
    label:
      arr.length === 1 ? children : arr.map(line => line.charAt(0)).join('.'),
  }
}
